import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4133a4a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "detail-info",
  id: "detail-base-info"
}
const _hoisted_2 = { class: "left-info" }
const _hoisted_3 = { class: "left-content" }
const _hoisted_4 = { class: "item-label" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "right-info" }
const _hoisted_7 = { class: "right-content" }
const _hoisted_8 = { class: "item-label right-item-label" }
const _hoisted_9 = { class: "item-value" }



interface IBaseInfoProps {
  book: Book | undefined;
  others: PartialUnionType;
  headers: PartialUnionType;
  baseInfo: IPartialUnionBaseInfo;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    book: null,
    others: null,
    headers: null,
    baseInfo: null
  },
  setup(__props: any) {

const props = __props as {
  book: Book | undefined;
  others: PartialUnionType;
  headers: PartialUnionType;
  baseInfo: IPartialUnionBaseInfo;
}

/* eslint-disable no-undef */


// console.log('book: ', props);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList({...__props.headers, ...__props.others}, (val, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "info-item",
            key: key
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(val), 1),
            _createElementVNode("div", {
              class: "item-value",
              title: __props.baseInfo[key]
            }, _toDisplayString(__props.baseInfo[key] || "--"), 9, _hoisted_5)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (__props.book && Object.keys(__props.book).length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.book, (val, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "info-item",
                key: key
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(val.label), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(__props.baseInfo[key] || "--") + "/" + _toDisplayString(__props.baseInfo[val.phoneKey] || "--"), 1)
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})